export default {
      id: "i-service-blog-min-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/sprite.svg#i-service-blog-min",
      toString: function () {
        return this.url;
      }
    }